import Vue from '@/vue'
import { createPinia, PiniaVuePlugin } from 'pinia'
import LoginPage from '@/auth/LoginPage.vue'
import TwoFactorSetupPage from '@/auth/TwoFactorSetupPage.vue'

if (document.getElementById('login-page')) {
  Vue.use(PiniaVuePlugin)
  const pinia = createPinia()

  new Vue({
    el: '#login-page',
    pinia,
    components: {
      LoginPage
    }
  })
}

if (document.getElementById('two-factor-setup-page')) {
  Vue.use(PiniaVuePlugin)
  const pinia = createPinia()

  new Vue({
    el: '#two-factor-setup-page',
    pinia,
    components: {
      TwoFactorSetupPage
    }
  })
}

export {}
